import React from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';

const LocalRedirect = ({ location }) => {
  return location ? <Redirect to={location} /> : null;
};

LocalRedirect.defaultProps = {
  location: null,
};

LocalRedirect.propTypes = {
  location: PropTypes.string,
};

export default LocalRedirect;
